var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_7273",
    d: "M0 0H26.938V23.329H0z",
    className: "cls-1"
  })), /*#__PURE__*/React.createElement("style", null, "\r\n            .cls-1{fill:currentColor}\r\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8410",
    transform: "translate(-68 -532)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_7438",
    fill: "none",
    d: "M0 0H31V31H0z",
    transform: "translate(68 532)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8409",
    transform: "translate(69.877 534.078)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8112",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5945",
    d: "M10.943 20.151v-1.976a1.034 1.034 0 0 1-.541-.33c-.445-.454-.786-1.278-1.287-1.879-.411-.516-.922-.668-1.11-1.215a2.953 2.953 0 0 1-.132-1 1.592 1.592 0 0 1 .75-1.44c0-.645-.024-1.281-.009-1.857a5.529 5.529 0 0 1 .405-2.537 1.954 1.954 0 0 1 1.206-1.042 1.33 1.33 0 0 1 .177-.04c1.027-.292 2.242-.18 3.258-.864h.607c.72.086.754.96 1.408 1.209a1.367 1.367 0 0 0 .465.081c.234 0 .436-.04.66-.04a.989.989 0 0 1 .586.166c1.176.8.528 3.311.594 5.024.075.319.633.177.718.5a10.814 10.814 0 0 1 0 2.214c-1.372.547-1.615 2.215-2.73 3.019-.81 3.058 1.245 3.15 3.535 3.619a5.681 5.681 0 0 1 3.138 1.567 13.469 13.469 0 1 0-18.521-.165c1.594-1.389 4.657-1.065 6.28-2.427a2.487 2.487 0 0 0 .541-.586",
    className: "cls-1",
    transform: "translate(0 -.001)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.3484872d15794fa638a53778b3a2b0a2.svg";
export { ForwardRef as ReactComponent };